import * as React from "react";
import { inject, observer } from "mobx-react";
import * as DocumentManagement from "../DocumentManagement";
import { PrivilegeMembership } from "../Shared";
import { NotificationStore } from "../Stores/NotificationStore";
import { DocumentStoreImpl } from "../Stores/DocumentStore";

interface IDocumentPrivilegeMembershipProps {
	groupId: string;
	document: DocumentManagement.DocumentDetails;
	item: PrivilegeMembership;
	documentStore?: DocumentStoreImpl;
	collectionId: string;
}

@inject('documentStore')
@observer
export class DocumentPrivilegeMembershipEdit extends React.Component<IDocumentPrivilegeMembershipProps, {}> {

	/* 
	* Getting Implicit Collection Privileges when the user clicks on any of the privilege memberships.
	* Seperated the logic for selected privilege and existing privileges. Because. we are merging the privileges only when the user clicks Save Button.
	*/
	handleChange = () => {
		NotificationStore.clearMessage();
		this.props.item.isExplicitMemberOf = !this.props.item.isExplicitMemberOf;
		this.props.documentStore.updateImplicitPrivileges(this.props.document, this.props.collectionId);
	}

	render() {

		let inheritMember = this.props.item.isImplicitMemberOf && !this.props.item.isExplicitMemberOf ? "checkbox-style is--inherited" : "checkbox-style";

		return <td data-test-id={this.props.item.name} data-test-name="privilegeRadioCheck">
			<label className="custom-radiocheck">
				<input type="checkbox" checked={this.props.item.isExplicitMemberOf || this.props.item.isImplicitMemberOf} onChange={this.handleChange} />
				<span className={inheritMember}></span>
				<span className="checkbox-name">
					{this.props.item.name}
				</span>
			</label>
		</td>;
	}
}